import React from "react";
import Provider from "./provider";
import useNotifications from "./notifications";

export function ExportController(props) {
	const notifications = useNotifications();
	return <Provider { ...notifications }  { ...props } />;
};

export { default as useExport } from "./useExport";
